import { render, staticRenderFns } from "./TagsCell.vue?vue&type=template&id=07256345&scoped=true"
import script from "./TagsCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagsCell.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TagsCell.vue?vue&type=style&index=0&id=07256345&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07256345",
  null
  
)

export default component.exports